module.exports = __webpack_public_path__ + "static/media/UnsupportedBrowser.e2d61acd.svg";